// extracted by mini-css-extract-plugin
module.exports = {"loader":"src-modules-dashboard-components-Charts-ProjectsViewsChart---loader---3T5hd"};